export default __webpack_public_path__ + "img/dWbstsVW.7fb03e28.svg";